import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  HomeIcon,
  ClockIcon,
  BanknotesIcon,
  ClipboardDocumentCheckIcon,
  MagnifyingGlassIcon,
  UserGroupIcon,
  FolderIcon,
  DocumentChartBarIcon,
  SparklesIcon,
} from '@heroicons/react/24/outline';

const navigation = [
  { name: 'nav.dashboard', href: '/dashboard', icon: HomeIcon },
  { name: 'nav.timeEntry', href: '/time-entry', icon: ClockIcon },
  { name: 'nav.tasks', href: '/tasks', icon: ClipboardDocumentCheckIcon },
  { name: 'nav.expenses', href: '/expenses', icon: BanknotesIcon },
  { name: 'nav.clients', href: '/clients', icon: UserGroupIcon },
  { name: 'nav.projects', href: '/projects', icon: FolderIcon },
  { name: 'nav.search', href: '/search', icon: MagnifyingGlassIcon },
  { name: 'nav.ask', href: '/ask', icon: SparklesIcon },
  { name: 'nav.reports', href: '/reports', icon: DocumentChartBarIcon },
];

export const Sidebar: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="bg-gray-50 dark:bg-gray-800 border-r border-gray-200 dark:border-gray-700 h-screen w-64 flex flex-col">
      {/* Logo */}
      <div className="p-4 border-b border-gray-200 dark:border-gray-700">
        <NavLink to="/dashboard" className="flex items-center">
          <span className="text-xl font-bold text-gray-900 dark:text-white">Auxilio</span>
          <img src="/favicon.svg" alt="" className="h-6 w-6 mx-1" />
          <span className="text-xl font-bold text-gray-900 dark:text-white">Time</span>
        </NavLink>
      </div>

      {/* Navigation */}
      <nav className="flex-1 overflow-y-auto p-4">
        <ul className="space-y-1">
          {navigation.map((item) => (
            <li key={item.href}>
              <NavLink
                to={item.href}
                className={({ isActive }) =>
                  `flex items-center px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                    isActive
                      ? 'bg-green-100 text-green-700 dark:bg-green-900 dark:text-green-200'
                      : 'text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700'
                  }`
                }
              >
                <item.icon className="h-5 w-5 mr-3" />
                {t(item.name)}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      {/* Footer */}
      <div className="px-4 py-3 border-t border-gray-200 dark:border-gray-700">
        <p className="text-xs text-green-600 dark:text-green-400 text-center font-light">
          Copyright 2026, Auxilio Technologies LLC
        </p>
      </div>
    </div>
  );
};
